import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './app/store/store';
import ReactDOM from 'react-dom/client';
import '../src/styles/global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { TicketDataProvider } from './context/ticketDataContext';
import { ThemeProvider, createTheme, THEME_ID } from '@mui/material/styles';
import { CssVarsProvider } from '@mui/joy/styles';
import { theme } from './themes/muiOverridesStyles';

const materialTheme = createTheme(theme);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    <Provider store={store}>
        {/* <PersistGate loading={null} persistor={persistor}> */}
        <ThemeProvider theme={{ [THEME_ID]: materialTheme }}>
            <CssVarsProvider>
                <TicketDataProvider>
                    <App />
                </TicketDataProvider>
            </CssVarsProvider>
        </ThemeProvider>
        {/* </PersistGate> */}
    </Provider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// used THEME_ID to avoid the errors related to theme.
